import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { InfiniteResult } from '../_models/body';

@Injectable({
  providedIn: 'root'
})
export class VirtualMallService {
  httpOptions: any = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<InfiniteResult>(`${environment.apiEndpoint}api/VirtualMall/Query`, {
      params: {
        PageSize: -1
      }
    });
  }

  // 创建虚拟商城
  create(virtualMallData: any) {
    return this.http.post(`${environment.apiEndpoint}api/VirtualMall`, virtualMallData);
  }

  // 更新虚拟商城
  update(id: string, virtualMallData: any) {
    return this.http.put(`${environment.apiEndpoint}api/VirtualMall/${id}`, virtualMallData);
  }

  // getById(id: string) {
  //   return this.http.get(`${environment.apiEndpoint}api/VirtualMall/${id}`);
  // }

  delete(id: string) {
    return this.http.delete(`${environment.apiEndpoint}api/VirtualMall/${id}`);
  }

}